// =============================================================================
// TEAM.JS — Single source of truth for team members (agents, admin, sales).
// =============================================================================
// `agents` is the array fetched from profiles (role in admin/agent/sales) in
// App.js via fetchTeam(). Pass it down via prop to any component that needs
// to enumerate team members. Don't hardcode names in components — derive here.
// =============================================================================

// Visual identity per agent. Add new ones here when someone joins; falls back
// to neutral gray for any unknown name. Cheap to maintain, expensive to move
// to DB (you'd need a color picker UI).
export const AGENT_COLORS = {
  'Steve':   '#3b82f6',
  'Mirelle': '#f97316',
  'Lydie':   '#10b981',
  'Loizza':  '#8b5cf6',
  'Katrina': '#ec4899',
  'Melody':  '#06b6d4',
  'Vincent': '#eab308',
  'Lari':    '#14b8a6',
}

export function getAgentColor(name) {
  return AGENT_COLORS[name] || '#6b7280'
}

// Returns just the agent names (sorted). Use in dropdowns / iteration.
export function getAgentNames(team) {
  return (team || []).map(t => t.agent_name).filter(Boolean)
}

// Filter to actual deal-handling agents (excludes sales role).
export function getDealAgents(team) {
  return (team || [])
    .filter(t => t.role === 'admin' || t.role === 'agent')
    .map(t => t.agent_name)
    .filter(Boolean)
}

// Shape used by the CRM Hub for per-person tabs.
export function getCrmPeople(team) {
  return (team || []).map(t => ({
    id: (t.agent_name || '').toLowerCase(),
    name: t.agent_name,
    uid: t.id,
  })).filter(p => p.id && p.name && p.uid)
}

// Look up monthly target from the team list (null if not set).
export function getAgentTarget(team, name) {
  const member = (team || []).find(t => t.agent_name === name)
  return member?.monthly_target ?? null
}
